import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "seoul-trade-line-chart",
  class: "apt-chart"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "최근 10년 거래량 추이", -1)
const _hoisted_3 = { class: "chart-area" }
const _hoisted_4 = {
  key: 1,
  class: "chart-skeleton"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineChart = _resolveComponent("LineChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.chartData !== null)
        ? (_openBlock(), _createBlock(_component_LineChart, {
            key: 0,
            class: "chart",
            data: _ctx.chartData,
            options: _ctx.chartOptions
          }, null, 8, ["data", "options"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, "그래프 불러오는 중…"))
    ])
  ]))
}